/* MARO Reseñas: lógica del formulario (paso 1: solo correo, se envía el enlace; paso 2: reseña con fotos). Backend: n8n. */
(function () {
  var root = document.getElementById('maro-review-form');
  if (!root) return;
  var ES = root.getAttribute('data-es') === 'true';
  var EP = root.getAttribute('data-endpoint');
  var T = ES ? {
    generic: 'No pudimos enviar tu reseña. Inténtalo de nuevo en un momento.',
    notfound: 'No encontramos ese pedido con ese correo. Revisa el número y el correo del pedido.',
    badlink: 'Este enlace no es válido. Escribe tu correo y te enviamos uno nuevo.',
    sent: 'Listo 💛 Si hay una compra con ese correo, te enviamos el enlace para escribir tu reseña. Mira también Promociones o Spam.', bademail: 'Escribe un correo válido.',
    fill: 'Completa los campos.', stars: 'Elige de 1 a 5 estrellas.', item: 'Elige la pieza.', short: 'Escribe al menos 10 caracteres.', consent: 'Marca la casilla para continuar.',
    sending: 'Enviando…', checking: 'Comprobando tu pedido…', remove: 'Quitar foto',
    add1: 'Añadir fotos', addN: 'Añadir otra foto', hint: 'Toca para elegir de tu galería o hacer una foto', ready: ' fotos listas',
    okPub: 'Tu reseña ya está publicada. ¡Gracias por ayudar a otras clientas!', okPend: 'Recibimos tu reseña. La revisaremos y se publicará pronto.', done: 'Esta pieza ya tiene tu reseña.', notbuyer: 'No encontramos una compra de esta pieza con ese correo. Usa el correo con el que compraste o escríbenos por WhatsApp.'
  } : {
    generic: 'We could not send your review. Please try again in a moment.',
    notfound: 'We could not find that order with that email. Check the order number and email.',
    badlink: 'This link is not valid. Enter your email and we will send you a new one.',
    sent: 'Done 💛 If there is a purchase with that email, we sent you the link to write your review. Check Promotions or Spam too.', bademail: 'Enter a valid email.',
    fill: 'Please fill in the fields.', stars: 'Choose 1 to 5 stars.', item: 'Choose the piece.', short: 'Write at least 10 characters.', consent: 'Tick the box to continue.',
    sending: 'Sending…', checking: 'Checking your order…', remove: 'Remove photo',
    add1: 'Add photos', addN: 'Add another photo', hint: 'Tap to pick from your gallery or take a photo', ready: ' photos ready',
    okPub: 'Your review is now published. Thank you for helping other shoppers!', okPend: 'We received your review. We will check it and it will be published soon.', done: 'This piece already has your review.', notbuyer: 'We could not find a purchase of this piece with that email. Use the email you bought with, or message us on WhatsApp.'
  };
  var MAXP = 3;
  var f1 = root.querySelector('[data-step="1"]'), f2 = root.querySelector('[data-step="2"]'), done = root.querySelector('[data-done]');
  var state = { order: '', email: '', tok: '', rating: 0, photos: [], t0: Date.now() };
  function msg(form, text, err) { var m = form.querySelector('[data-msg]'); m.textContent = text || ''; m.classList.toggle('is-err', !!err); }
  function post(body) {
    return fetch(EP, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
  }
  var qs = new URLSearchParams(location.search), want = qs.get('product') || qs.get('p'), TOK = qs.get('t'), ORD = qs.get('o');
  function enter(r) {
    var box = f2.querySelector('[data-items]'); box.innerHTML = '';
    var avail = 0;
    r.items.forEach(function (it) {
      var l = document.createElement('label');
      var inp = document.createElement('input'); inp.type = 'radio'; inp.name = 'item'; inp.value = it.handle; inp.disabled = !!it.reviewed;
      if (!it.reviewed) { avail++; if (it.handle === want || avail === 1 && !want) inp.checked = true; }
      l.appendChild(inp);
      if (it.image) { var im = document.createElement('img'); im.src = it.image; im.alt = ''; l.appendChild(im); }
      var s = document.createElement('span'); s.textContent = it.title + (it.reviewed ? ' — ' + T.done : ''); l.appendChild(s);
      box.appendChild(l);
    });
    f1.hidden = true; f2.hidden = false; f2.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  if (TOK && ORD && want) {
    f1.hidden = true;
    post({ action: 'verify', order: ORD, handle: want, t: TOK }).then(function (r) {
      if (r && r.ok) { state.order = ORD; state.tok = TOK; enter(r); }
      else { f1.hidden = false; msg(f1, T.badlink, true); }
    }).catch(function () { f1.hidden = false; msg(f1, T.generic, true); });
  }
  else if (want) {
    f1.hidden = true; f2.hidden = false; root.classList.add('is-direct');
    var box = f2.querySelector('[data-items]'); box.innerHTML = '';
    var l = document.createElement('label'), inp = document.createElement('input'), s = document.createElement('span');
    inp.type = 'radio'; inp.name = 'item'; inp.value = want; inp.checked = true; l.appendChild(inp); s.textContent = want.replace(/-/g, ' '); l.appendChild(s); box.appendChild(l);
    var root_ = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root_ + 'products/' + encodeURIComponent(want) + '.js').then(function (r) { return r.json(); }).then(function (p) {
      s.textContent = p.title;
      if (p.featured_image) { var im = document.createElement('img'); im.src = p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2'); im.alt = ''; l.insertBefore(im, s); }
    }).catch(function () {});
  }
  f1.addEventListener('submit', function (e) {
    e.preventDefault();
    var m = f1.email.value.trim();
    if (!m) return msg(f1, T.fill, true);
    var btn = f1.querySelector('button[type="submit"]'); btn.disabled = true; msg(f1, T.sending);
    fetch(root.getAttribute('data-link'), { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify({ email: m, handle: want || '', lang: ES ? 'es' : 'en', hp: f1.website.value }) })
      .then(function (r) { return r.json(); }).then(function (r) {
        if (r && r.ok) { msg(f1, T.sent, false); setTimeout(function () { btn.disabled = false; }, 30000); }
        else { btn.disabled = false; msg(f1, T.bademail, true); }
      }).catch(function () { btn.disabled = false; msg(f1, T.generic, true); });
  });
  f2.querySelectorAll('[data-star]').forEach(function (b) {
    b.addEventListener('click', function () {
      state.rating = parseInt(b.getAttribute('data-star'), 10);
      f2.querySelectorAll('[data-star]').forEach(function (x) {
        var n = parseInt(x.getAttribute('data-star'), 10);
        x.classList.toggle('on', n <= state.rating); x.setAttribute('aria-checked', String(n === state.rating));
      });
    });
  });
  function compress(file) {
    return new Promise(function (res) {
      var img = new Image(), url = URL.createObjectURL(file);
      img.onload = function () {
        var max = 1400, sc = Math.min(1, max / Math.max(img.width, img.height));
        var c = document.createElement('canvas'); c.width = Math.round(img.width * sc); c.height = Math.round(img.height * sc);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url); res(c.toDataURL('image/jpeg', 0.82));
      };
      img.onerror = function () { URL.revokeObjectURL(url); res(null); };
      img.src = url;
    });
  }
  var prev = f2.querySelector('[data-prev]'), dropT = f2.querySelector('[data-drop-t]'), dropS = f2.querySelector('[data-drop-s]'), drop = f2.querySelector('[data-drop]');
  function render() {
    prev.innerHTML = '';
    state.photos.forEach(function (d, i) {
      var w = document.createElement('div'); w.className = 'maro-rf__thumb';
      var im = document.createElement('img'); im.src = d; im.alt = '';
      var x = document.createElement('button'); x.type = 'button'; x.setAttribute('aria-label', T.remove); x.textContent = '×';
      x.addEventListener('click', function () { state.photos.splice(i, 1); render(); });
      w.appendChild(im); w.appendChild(x); prev.appendChild(w);
    });
    var n = state.photos.length;
    dropT.textContent = n ? T.addN : T.add1;
    dropS.textContent = n ? (n + ' / ' + MAXP + T.ready) : T.hint;
    drop.classList.toggle('is-full', n >= MAXP);
    f2.photos.disabled = n >= MAXP;
  }
  f2.photos.addEventListener('change', function () {
    var files = Array.prototype.slice.call(f2.photos.files, 0, MAXP - state.photos.length);
    f2.photos.value = '';
    Promise.all(files.map(compress)).then(function (arr) {
      arr.filter(Boolean).forEach(function (d) { if (state.photos.length < MAXP) state.photos.push(d); });
      render();
    });
  });
  f2.addEventListener('submit', function (e) {
    e.preventDefault();
    var item = f2.querySelector('input[name="item"]:checked');
    if (!item) return msg(f2, T.item, true);
    if (!state.rating) return msg(f2, T.stars, true);
    if (f2.body.value.trim().length < 10) return msg(f2, T.short, true);
    if (!f2.author.value.trim()) return msg(f2, T.fill, true);
    if (!f2.consent.checked) return msg(f2, T.consent, true);
    var btn = f2.querySelector('button[type="submit"]'); btn.disabled = true; msg(f2, T.sending);
    var body = { action: 'submit', order: state.order, handle: item.value, rating: state.rating, title: f2.title.value.trim(), body: f2.body.value.trim(), author: f2.author.value.trim(), photos: state.photos, lang: ES ? 'es' : 'en', elapsed: Date.now() - state.t0 };
    body.hp = f2.website.value;
    if (state.tok) body.t = state.tok;
    post(body).then(function (r) {
      if (r && r.ok) { f2.hidden = true; done.hidden = false; done.querySelector('[data-done-text]').textContent = r.published ? T.okPub : T.okPend; done.scrollIntoView({ behavior: 'smooth' }); }
      else { btn.disabled = false; msg(f2, (r && r.error === 'duplicate') ? T.done : (r && r.error === 'notfound') ? T.notbuyer : T.generic, true); }
    }).catch(function () { btn.disabled = false; msg(f2, T.generic, true); });
  });
})();